import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, memberships, membershipsLoaded } = useAuth();
  const location = useLocation();
  if (user === null || (user && !membershipsLoaded)) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-zinc-950" data-testid="auth-loading">
        <div className="font-display text-zinc-500 tracking-wider uppercase text-sm">Lädt…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  // Kein aktives Team → Mannschaft auswählen (Super-Admin darf zur /super-Verwaltung ohne Team)
  if (!user.active_team_id
      && location.pathname !== "/mannschaft-waehlen"
      && !(user.is_super_admin && location.pathname.startsWith("/super"))) {
    return <Navigate to="/mannschaft-waehlen" replace />;
  }
  return children;
}
